import React from "react";
import { connect } from "react-redux";
import { Field, reduxForm } from "redux-form";
import { database } from "../app-database";
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import TextField from 'material-ui/TextField';
import ModalSintillo from '../mensajes-tooltips/mensajes-tooltips.cmpt';

const ojito = "eye-visible";
const ojitoCerrado = "eye-hidden";
const iconCircule = "icon-circle";
const iconCirculeDove = "icon-circle-dove";
const iconCirculeDovequis = "icon-equis-circulo"
const modalValidPass = "modal-validador-password";
const modalValidPassBody = "modal-validador-password-body";
const estiloCol = "col-md-6 col-sm-6 col-xs-12";
const estiloColpx = "0px 8px 0px 0px";
const colorNormal = "colorNormal";
const colorExito = "colorExito";
const colorError = "colorError";
let msgTitulo = "";
let mostrarHr = true;

const mapState = (state) => {
    return {
        dispositivo: state.global.dispositivo,
        preguntas1: state.catalogos.catalogoPregunta1,
        preguntas2: state.catalogos.catalogoPregunta2
    };
};

const mapDispatch = (dispatch) => {
    return {
        regresar: (disp) => {
            dispatch({ "type": "EVENT_REGISTRO_DP-REGRESAR", "dispositivo": disp });
            dispatch({ "type": "REGISTRO_PASO", "paso": 1 });
        },
        avisoPrivacidad: (showAviso) => {
            dispatch({ "type": "AVISO_PRIVACIDAD", "showAviso": showAviso });
        },
        llenarPreguntas: (cat1, cat2) => {
            dispatch({ "type": "CARGAR_CATALOGO_PREGUNTAS", catalogoPregunta1: cat1, catalogoPregunta2: cat2 });
        },
        tagManager: (oDataTagManager) => {
            dispatch(oDataTagManager);
        }
    };
};

const campo = ({ input, label, type, max, meta: { touched, error } }) => {
    return (
        <MuiThemeProvider>
            <TextField
                {...input}
                floatingLabelText={label}
                fullWidth={true}
                underlineStyle={{ borderColor: '#AAC3EE' }}
                underlineFocusStyle={{ borderColor: '#FF6B0B' }}
                floatingLabelStyle={floatingLabelStyleSettings}
                floatingLabelFocusStyle={floatingLabelFocusStyleSettings}
                type={type}
                errorText={touched && error}
                maxLength={max}
                onChange={(event) => { input.onChange(event); }}


                onKeyPress={(event) => {
                    if (event.key === 'Enter') {
                        handleKeyPress(input);
                    }
                }}
            />
        </MuiThemeProvider>
    );
};

const handleKeyPress = (input) => {
    const inputs = document.getElementsByTagName('input');
    const inputActual = input.name;
    for (let index = 0; index < inputs.length; index++) {
        if (inputActual === inputs[index].name) {
            switch (input.name) {
                case "confpassword":
                    document.getElementById(inputs[index].id).blur();
                    break;
                case "password":
                    document.getElementById(inputs[index + 1].id).focus();
                    break;
                default:
                    break;
            }
        }
    }
}

const campoSettings = {
    fontFamily: 'OpenSans',
    fontStyle: 'normal',
    fontWeight: 'normal',
    mixBlendMode: 'normal',
};

const floatingLabelStyleSettings = {
    ...campoSettings,
    lineHeight: '16px',
    letterSpacing: '0.5px',
    color: '#567099'
};

const floatingLabelFocusStyleSettings = {
    ...campoSettings,
    lineHeight: '16px',
    letterSpacing: '0.4px',
    color: '#FF6B0B',
};

class FormularioSeguridad extends React.Component {

    claseCaracteresCompletos = "";
    state = {
        showValidatorPass: false,
        caracteresCompletos: 'vacio',
        caracteresAlfaNumericos: 'vacio',
        caracterMayuscula: 'vacio',
        caracterGNP: 'vacio',
        caracterConsecutivoIgual: 'vacio',
        caracterConsecutivo: 'vacio',
        espacioEnBlanco: 'vacio',
        caracteresNumericos: 'vacio',
        caracterEspecial: 'vacio',
        contraExitosa: false,
        btnHabilitado: 'deshabilita',
        showPass: true,
        showConfPass: true,
        showResp1: true,
        showResp2: true,
        password: "",
        confPassword: "",
        respuesta1: "",
        respuesta2: "",
        loadingPequeno: false,
        pregunta1: 0,
        pregunta2: 0,
        validate: {
            password: false,
            confPassword: false,
            respuesta1: false,
            respuesta2: false,
        },
        showTooltip: false,
        mensaje: "",
        type: "",
        titulo: ""
    }

    viewPass = () => {
        this.setState({ showPass: !this.state.showPass });
    }

    viewPassConf = () => {
        this.setState({ showConfPass: !this.state.showConfPass });
    }

    componentWillMount = () => {
        database.ref("preguntas").on("value", snapshot => {
            const data = snapshot.val();
            this.props.llenarPreguntas(data.pregunta1, data.pregunta2);
        });
    }

    handleChange = (sParam, e) => {
        this.setState({ [sParam]: e.target.value });
        this.validate(sParam, e.target.value);
    }

    lanzaErrorContra = (bandera) => {
        if (bandera) {
            setTimeout(() => {
                this.setState({ contraExitosa: bandera });
            }, 100);
        } else {
            this.setState({ contraExitosa: bandera });
        }
    }

    confirmPassword = () => {
        const valuePassword = document.getElementsByName('password')[0].value;
        const confirPassword = document.getElementsByName('confpassword')[0].value;

        if (confirPassword !== '' && valuePassword !== '') {

            if (valuePassword === confirPassword) {
                console.log('entro 1');
                this.lanzaErrorContra(true);
                this.muestraTooltip(false);
            } else {
                console.log('entro 2');
                this.lanzaErrorContra(false);
                this.muestraTooltip(true, 'error', 'Error', 'Las contraseñas no coinciden');
                this.setState({ btnHabilitado: 'deshabilita' });
            }
        } else {
            this.lanzaErrorContra(false);
            this.validaBotonDeshabilitado();
        }
        setTimeout(() => {
            this.validaBotonDeshabilitado();
        }, 200);
    }

    muestraTooltip = (show, type?, titulo?, mensaje?) => {
        setTimeout(() => {
            this.setState({ showTooltip: show, type: type, titulo: titulo, mensaje: mensaje });
        }, 300);
    }

    cierraTooltip = e => {
        this.setState({
            showTooltip: !this.state.showTooltip
        });
    }

    validaPassword = () => {
        const valuePassword = document.getElementsByName('password')[0].value;
        function checkMayus(str) {
            return str.toLowerCase() !== str;
        }
        if (valuePassword === '') {
            this.setState({ caracteresCompletos: 'vacio' });
            this.setState({ caracteresAlfaNumericos: 'vacio' });
            this.setState({ caracterMayuscula: 'vacio' });
            this.setState({ caracterGNP: 'vacio' });
            this.setState({ caracterConsecutivoIgual: 'vacio' });
            this.setState({ espacioEnBlanco: 'vacio' });
            this.setState({ caracteresNumericos: 'vacio' });
            this.setState({ caracterEspecial: 'vacio' });
            this.setState({ caracterConsecutivo: 'vacio' });
        } else {
            this.caracterConFunc(valuePassword);
            this.caracteresLetras(valuePassword);
            this.caracteresMayusLetra(valuePassword);
            this.caracteresAlfan(valuePassword);
            checkMayus(valuePassword) === false ? this.setState({ caracterMayuscula: 'error' }) : this.setState({ caracterMayuscula: 'exito' });
        }
        setTimeout(() => {
            this.validaBotonDeshabilitado();
        }, 300);
    }

    caracteresMayusLetra = (valuePassword) => {
        (/\s+/.test(valuePassword)) ? this.setState({ espacioEnBlanco: 'error' }) : this.setState({ espacioEnBlanco: 'exito' });
        valuePassword.length <= 7 || valuePassword.length > 24 ? this.setState({ caracteresCompletos: 'error' }) : this.setState({ caracteresCompletos: 'exito' });
        valuePassword.toLowerCase().includes("gnp") ? this.setState({ caracterGNP: 'error' }) : this.setState({ caracterGNP: 'exito' });
    }

    caracteresAlfan = (valuePassword) => {
        var contador = 0;
        var letras = "abcdefghyjklmnñopqrstuvwxyz";
        var letras_mayusculas = "ABCDEFGHYJKLMNÑOPQRSTUVWXYZ";
        for (var i = 0; i < valuePassword.length; i++) {
            if ((letras.indexOf(valuePassword.charAt(i), 0) !== -1) || letras_mayusculas.indexOf(valuePassword.charAt(i), 0) !== -1) {
                contador = contador + 1;
            } else {
                console.log('no existe alfabetico');
            }
        }

        if (contador >= 4) {
            this.setState({ caracteresAlfaNumericos: 'exito' });
        } else {
            this.setState({ caracteresAlfaNumericos: 'error' });
        }
    }

    caracterConFunc = (valuePassword) => {
        const ABC = "abcdefghijklmnopqrstuvwxyz", NUMEROS = "0123456789";
        for (var i = 0; i < valuePassword.length; i++) {
            var cadena = valuePassword.substr(i, 3).toLowerCase();
            if (cadena.length === 3 && (ABC.indexOf(cadena) >= 0 || NUMEROS.indexOf(cadena) >= 0)) {
                this.setState({ caracterConsecutivo: 'error' });
                break;
            } else {
                this.setState({ caracterConsecutivo: 'exito' });
            }
        }

        (/([\w])\1{2,}/.test(valuePassword)) ? this.setState({ caracterConsecutivoIgual: 'error' }) : this.setState({ caracterConsecutivoIgual: 'exito' });
    }

    caracteresLetras = (valuePassword) => {
        (/[0-9]/.test(valuePassword) === false) ? this.setState({ caracteresNumericos: 'error' }) : this.setState({ caracteresNumericos: 'exito' });
        (!/^[a-z0-9]+$/i.test(valuePassword)) ? this.setState({ caracterEspecial: 'exito' }) : this.setState({ caracterEspecial: 'error' });
    }

    validaBotonDeshabilitado = () => {
        if (this.state.contraExitosa && this.state.caracteresCompletos === 'exito' && this.state.caracteresAlfaNumericos === 'exito'
            && this.state.caracterMayuscula === 'exito'
            && this.state.caracterGNP === 'exito' && this.state.espacioEnBlanco === 'exito' && this.state.caracterConsecutivoIgual === 'exito'
            && this.state.caracteresNumericos === 'exito' && this.state.caracterEspecial === 'exito'
            && this.state.caracterConsecutivo === 'exito') {
            this.setState({ btnHabilitado: 'habilita' });
        } else {
            this.setState({ btnHabilitado: 'deshabilita' });
        }
    }

    validaCaracteresIcon = (value) => {
        if (this.state[value] === 'vacio') {
            return iconCircule;
        } else if (this.state[value] === 'exito') {
            return iconCirculeDove;
        } else {
            return iconCirculeDovequis;
        }
    }

    validaCaracteresColor = (value) => {
        if (this.state[value] === 'vacio') {
            return colorNormal;
        } else if (this.state[value] === 'exito') {
            return colorExito;
        } else {
            return colorError;
        }
    }

    handleFocusPassword = () => {
        this.setState({ showValidatorPass: true });
    }

    handleBlurPassword = () => {
        if (this.state.caracteresCompletos === 'exito' && this.state.caracterMayuscula === 'exito'
            && this.state.caracteresAlfaNumericos === 'exito'
            && this.state.caracterGNP === 'exito' && this.state.espacioEnBlanco === 'exito' && this.state.caracterConsecutivoIgual === 'exito'
            && this.state.caracteresNumericos === 'exito' && this.state.caracterEspecial === 'exito'
            && this.state.caracterConsecutivo === 'exito') {
            this.setState({ showValidatorPass: false });
        } else {
            this.setState({ showValidatorPass: true });
        }
        this.validaPasswordConfirm();
    }

    validaPasswordConfirm = () => {
        const confpassword = document.getElementsByName('confpassword')[0].value;
        if (confpassword !== '') {
            console.log('entro')
            this.confirmPassword();
        }
    }

    toggle = (sParam) => {
        this.setState({ [sParam]: !this.state[sParam] });
    }

    handleSelect = (sParam, e) => {
        this.setState({ [sParam]: e });
    }

    componentDidMount = () => {
        const url = window.location.hash;
        if (url.includes("#!/gnp/registro-agt")) {
            msgTitulo = "Crea una contraseña";
            mostrarHr = false;
        } else {
            msgTitulo = "CONTRASEÑA";
            mostrarHr = true;
        }

        $(".pass, .confpass").bind("copy paste", function (e) {
            e.preventDefault();
            return false;
        });
    }

    render() {
        return <div>
            <ModalSintillo onClose={this.cierraTooltip} titulo={this.state.titulo}
                show={this.state.showTooltip} type={this.state.type} mensaje={this.state.mensaje}>
            </ModalSintillo>

            <div className="datos-wrap mt-10" id="datos-wrap" style={{ marginTop: "35px" }}>
                <label className="txt-2" id="textSeguridad" style={{ marginTop: "28px", marginLeft: "5px", fontSize: "14px" }}>{msgTitulo}</label>
                <div className="row">
                    <div className={estiloCol} id="campo-password-seguridad" style={{ marginLeft: "5px" }}>
                        <Field
                            name="password" label="Contraseña" component={campo} max="24" type={this.state.showPass ? "password" : "text"}
                            onChange={this.validaPassword} onFocus={this.handleFocusPassword} onBlur={this.handleBlurPassword}
                            props={{ param: this.state.showPass, fnToggle: this.toggle.bind(this, "showPass") }}
                        />
                        <button type="button" className={this.state.showPass ? ojito : ojitoCerrado} onClick={() => { this.viewPass() }}></button>
                        {this.state.showValidatorPass &&
                            <div className={modalValidPass} style={{ position: 'relative' }}>
                                <div className={modalValidPassBody}>
                                    <span style={{ margin: { estiloColpx }, width: '10%' }} className={this.validaCaracteresIcon('caracteresCompletos')} >
                                    </span>
                                    <div className={this.validaCaracteresColor('caracteresCompletos')} >
                                        <label className="label-text-modal-password">Debe ser al menos de 8 caracteres y máximo 24 caracteres.</label>
                                    </div>
                                </div>
                                <div className={modalValidPassBody}>
                                    <span style={{ margin: { estiloColpx } }} className={this.validaCaracteresIcon('caracterMayuscula')} >
                                    </span>
                                    <div className={this.validaCaracteresColor('caracterMayuscula')}>
                                        <label className="label-text-modal-password">Debe contener al menos una mayúscula.</label>
                                    </div>
                                </div>
                                <div className={modalValidPassBody}>
                                    <span style={{ margin: { estiloColpx }, width: '28px' }} className={this.validaCaracteresIcon('caracteresAlfaNumericos')} >
                                    </span>
                                    <div className={this.validaCaracteresColor('caracteresAlfaNumericos')}>
                                        <label className="label-text-modal-password">Debe contener al menos cuatro caracteres alfabéticos.</label>
                                    </div>
                                </div>
                                <div className={modalValidPassBody}>
                                    <span style={{ margin: { estiloColpx }, width: '8%' }} className={this.validaCaracteresIcon('caracteresNumericos')} >
                                    </span>
                                    <div className={this.validaCaracteresColor('caracteresNumericos')}>
                                        <label className="label-text-modal-password">Debe contener al menos un caracter numerico.</label>
                                    </div>
                                </div>
                                <div className={modalValidPassBody}>
                                    <span style={{ margin: { estiloColpx }, width: '8%' }} className={this.validaCaracteresIcon('caracterEspecial')} >
                                    </span>
                                    <div className={this.validaCaracteresColor('caracterEspecial')}>
                                        <label className="label-text-modal-password">Debe contener al menos un caracter especial.</label>
                                    </div>
                                </div>
                                <div className={modalValidPassBody}>
                                    <span style={{ margin: { estiloColpx } }} className={this.validaCaracteresIcon('caracterGNP')} >
                                    </span>
                                    <div className={this.validaCaracteresColor('caracterGNP')}>
                                        <label className="label-text-modal-password">No debe contener la palabra GNP.</label>
                                    </div>
                                </div>
                                <div className={modalValidPassBody}>
                                    <span style={{ margin: { estiloColpx }, width: '13%' }} className={this.validaCaracteresIcon('caracterConsecutivoIgual')} >
                                    </span>
                                    <div className={this.validaCaracteresColor('caracterConsecutivoIgual')}>
                                        <label className="label-text-modal-password">No debe contener más de dos caracteres
                                            consecutivos iguales (p.e. 222, eee).</label>
                                    </div>
                                </div>
                                <div className={modalValidPassBody}>
                                    <span style={{ margin: { estiloColpx }, width: '13%' }} className={this.validaCaracteresIcon('caracterConsecutivo')} >
                                    </span>
                                    <div className={this.validaCaracteresColor('caracterConsecutivo')}>
                                        <label className="label-text-modal-password">No debe contener más de dos caracteres
                                            consecutivos (p.e. 123, abc).</label>
                                    </div>
                                </div>
                                <div className={modalValidPassBody}>
                                    <span style={{ margin: { estiloColpx } }} className={this.validaCaracteresIcon('espacioEnBlanco')} >
                                    </span>
                                    <div className={this.validaCaracteresColor('espacioEnBlanco')}>
                                        <label className="label-text-modal-password">No debe contener espacios en blanco.</label>
                                    </div>
                                </div>
                            </div>}
                    </div>

                    <div className={estiloCol} id="campo-confPassword-seguridad">
                        <Field
                            name="confpassword" label="Confirmar contraseña" component={campo} max="24"
                            type={this.state.showConfPass ? "password" : "text"} onBlur={this.confirmPassword}
                            props={{ param: this.state.showConfPass, fnToggle: this.toggle.bind(this, "showConfPass"), clase: "confpass" }}
                        />
                        <button type="button" className={this.state.showConfPass ? ojito : ojitoCerrado} onClick={() => { this.viewPassConf() }}></button>
                    </div>
                </div>

                {mostrarHr === true && <div className="row">
                    <div className="col-md-2">
                        <button id="btn-continuar-seguridad"
                            style={{ width: '120px', height: '48px', fontSize: '16px', padding: '14px 16px', marginTop: '34px', marginLeft: "10px" }}
                            className="orange-rectangle">Continuar</button>
                    </div>
                </div>}
            </div>
        </div>;
    }
}

FormularioSeguridad = reduxForm({ form: "datosSeguridad" })(FormularioSeguridad);
export default connect(mapState, mapDispatch)(FormularioSeguridad);


// WEBPACK FOOTER //
// ./src/gnp-registro-seguridad/formulario-seguridad.cmpt.js